import { logRtcSfuRecovery, summarizeRtcSfuError } from "./rtc-sfu-recovery-debug";

export const CHAT_DELIVERY_TRANSPORT = {
  DIALOG: "dialog",
  RETICULUM: "reticulum",
  NONE: "none"
};

function getDefaultDialog() {
  return typeof window !== "undefined" ? window.APP?.dialog : null;
}

export function shouldUseDialogChat({ dialog = getDefaultDialog() } = {}) {
  return typeof dialog?.sendChatMessage === "function";
}

export function dispatchPublicChatMessage({ message, dialog = getDefaultDialog() } = {}) {
  if (!message) {
    return CHAT_DELIVERY_TRANSPORT.NONE;
  }

  if (shouldUseDialogChat({ dialog })) {
    logRtcSfuRecovery("chat:dispatch-public", {
      transport: CHAT_DELIVERY_TRANSPORT.DIALOG,
      hasMessage: Boolean(message),
      messageLength: typeof message === "string" ? message.length : undefined,
      protooConnected: Boolean(dialog?._protoo?.connected),
      dialogJoined: Boolean(dialog?._dialogJoined)
    });
    dialog.sendChatMessage({ text: message }).catch(error => {
      logRtcSfuRecovery("chat:dispatch-public-error", {
        transport: CHAT_DELIVERY_TRANSPORT.DIALOG,
        protooConnected: Boolean(dialog?._protoo?.connected),
        dialogJoined: Boolean(dialog?._dialogJoined),
        error: summarizeRtcSfuError(error)
      });
      console.warn("[chat] Dialog chat failed", error);
    });

    return CHAT_DELIVERY_TRANSPORT.DIALOG;
  }

  logRtcSfuRecovery("chat:dispatch-public", {
    transport: CHAT_DELIVERY_TRANSPORT.NONE,
    hasMessage: Boolean(message),
    messageLength: typeof message === "string" ? message.length : undefined
  });
  console.warn("[chat] Dialog chat is unavailable");
  return CHAT_DELIVERY_TRANSPORT.NONE;
}
